import { render } from "./waterWayDetail.vue?vue&type=template&id=6178da54&scoped=true"
import script from "./waterWayDetail.vue?vue&type=script&lang=js"
export * from "./waterWayDetail.vue?vue&type=script&lang=js"

import "./waterWayDetail.vue?vue&type=style&index=0&id=6178da54&lang=scss&scoped=true"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6178da54"]])

export default __exports__